<template>
    <nav class="no-print">
        <v-app-bar fixed fade-on-scroll flat :color="backgroundColor" dense app clipped-left>
            <v-spacer></v-spacer>
            <!-- <v-menu offset-y left open-on-click open-on-hover close-delay="100" v-if="isAuthenticated && $route.params.organizationId">
                <template #activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="blue--text text--darken-2">
                        <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                    </v-btn>
                </template>
                <v-list class="ma-0 pa-0">
                    <v-list-item :to="{ name: 'organization-create-product', params: { organizationId: $route.params.organizationId } }">
                        <v-list-item-icon>
                            <font-awesome-icon :icon="['fas', 'box']" class="blue--text text--darken-2" fixed-width/>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                New Product
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu> -->
            <v-menu v-model="helpMenu" offset-y open-on-click open-on-hover close-delay="100">
                <template #activator="{ on, attrs }">
                    <v-btn icon :color="primaryColor" v-bind="attrs" v-on="on">
                        <!-- TODO: when we upgrade to fontawesome 6.x this should be changed to 'message-question', or at least check how it looks that way -->
                        <font-awesome-icon :icon="['fas','question']" fixed-width/>
                    </v-btn>
                </template>
                <v-card>
                    <v-card-text>
                        Questions or comments?
                        <a href="https://cryptium.com/contact/" target="_blank">Contact us!</a>
                    </v-card-text>
                </v-card>
            </v-menu>
            <!-- <v-menu v-model="securityMenu" offset-y open-on-click open-on-hover close-delay="100">
                <template #activator="{ on, attrs }">
                    <v-btn icon :color="primaryColor" v-bind="attrs" v-on="on">
                        <font-awesome-icon :icon="['fas','shield-alt']" fixed-width/>
                    </v-btn>
                </template>
                <v-card>
                    <v-card-text>
                        Logout
                        or
                        remember me
                    </v-card-text>
                </v-card>
            </v-menu> -->
            <!-- <v-btn outlined color="blue darken-2" v-if="!isAuthenticated" @click="login">
                Sign in
            </v-btn> -->
            <!-- <v-menu offset-y left open-on-click open-on-hover close-delay="100" v-if="isAuthenticated">
                <template #activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="blue--text text--darken-2">
                        <Avatar :attr="mainProfile" :size="36"/>
                    </v-btn>
                </template>
                <v-list class="ma-0 pa-0">
                    <v-list-item :to="{ name: 'dashboard' }">
                        <v-list-item-icon>
                            <font-awesome-icon :icon="['fas', 'chart-line']" class="blue--text text--darken-2" fixed-width/>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                Dashboard
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'profile' }">
                        <v-list-item-icon>
                            <font-awesome-icon :icon="['fas', 'user']" class="blue--text text--darken-2" fixed-width/>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                Profile
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'settings' }">
                        <v-list-item-icon>
                            <font-awesome-icon :icon="['fas', 'cog']" class="blue--text text--darken-2" fixed-width/>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                Settings
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'service-admin' }" v-if="isPermitServiceAdmin">
                        <v-list-item-icon>
                            <font-awesome-icon :icon="['fas', 'id-badge']" class="blue--text text--darken-2" fixed-width/>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                Service Admin
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item @click="onLogout">
                        <v-list-item-icon>
                            <font-awesome-icon :icon="['fas', 'shield-alt']" class="blue--text text--darken-2" fixed-width/>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                Logout
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu> -->
        </v-app-bar>
    </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import Avatar from '@/components/Avatar.vue';

export default {
    components: {
        // Avatar,
    },

    data: () => ({
        helpMenu: false,
        // securityMenu: false,
    }),

    computed: {
        ...mapState({
            isAuthenticated: (state) => state.session.isAuthenticated,
            user: (state) => state.user,
        }),
        ...mapGetters({
            isLoading: 'isLoading',
            isAuthenticatedReady: 'isAuthenticatedReady',
            brandName: 'brandName',
            primaryColor: 'primaryColor',
            primaryTextColor: 'primaryTextColor',
            accentColor: 'accentColor',
            cardTitleBarTextStyle: 'cardTitleBarTextStyle',
            cardTitleBarStyle: 'cardTitleBarStyle',
            primaryButtonStyle: 'primaryButtonStyle',
            primaryIconStyle: 'primaryIconStyle',
        }),
        backgroundColor() {
            const defaultBackgroundColor = '#efefef'; // light grey
            return defaultBackgroundColor;
        },
        backgroundStyle() {
            const defaultBackgroundColor = '#efefef'; // light grey
            /*
            let backgroundColor;
            if (this.brand && Array.isArray(this.palette?.content?.background)) {
                backgroundColor = this.palette.content.background[0].hex;
            } else {
                backgroundColor = defaultBackgroundColor;
            }
            // TODO: input validation that backgroundColor is a valid hex color value or html color name
            return `background-color: ${backgroundColor}`;
            */
            return `background-color: ${defaultBackgroundColor}`;
        },
        mainProfile() {
            return { name: this.user.name, email: this.user.email };
        },
        isPermitServiceAdmin() {
            return this.isAuthenticated && Array.isArray(this.user?.permit?.role) && this.user.permit.role.includes('service-admin');
        },
    },

    methods: {
        login() {
            const { fullPath } = this.$router.currentRoute;
            this.$router.push({ path: '/login', query: { next: fullPath } });
        },
        async onLogout() {
            console.log('onLogout: redirecting to front page');
            await this.$store.dispatch('logout');
            if (this.$route.name !== 'front') {
                this.$router.push({ name: 'front' });
            }
        },
    },

    mounted() {
        console.log(`navbar route params ${JSON.stringify(this.$route.params)}`);
        if (this.$route.params.realmId) {
            console.log(`navabar realm ${this.$route.params.realmId}`);
        } else {
            console.log('navbar no realm');
        }
    },
};
</script>

<style>
    @media print {
        .no-print {
            display: none !important;
        }
    }
    @media screen {
        div.menutabs div[role="tablist"] { width: 100%; }
        div.menutabs [role="tab"] { justify-content: flex-start; padding-left: 48px;}
    }
</style>
